import { accountApi } from "../../config/apiConfig";
import { SetupFee } from "../../types/onboarding";

// The onboarding setup fee (CWA-196) on acc-management. Both decisions answer
// with the fee's new state, so the caller never has to re-read it.

// GET /admin/prospects/{id}/setup-fee — NOT_DUE until the prospect is promoted.
export const getSetupFee = async (id: string): Promise<SetupFee> => {
  const response = await accountApi.get(`admin/prospects/${id}/setup-fee`);
  return response.data;
};

// POST /admin/prospects/{id}/setup-fee/invoice — creates a DRAFT invoice in
// Easybill. Safe to retry: a retry adopts a draft an earlier attempt created.
// The empty body matters: this service answers a bodyless POST with 415.
export const invoiceSetupFee = async (id: string): Promise<SetupFee> => {
  const response = await accountApi.post(
    `admin/prospects/${id}/setup-fee/invoice`,
    {}
  );
  return response.data;
};

// POST /admin/prospects/{id}/setup-fee/waive — reason is 1–1000 chars, trimmed.
export const waiveSetupFee = async (
  id: string,
  reason: string
): Promise<SetupFee> => {
  const response = await accountApi.post(
    `admin/prospects/${id}/setup-fee/waive`,
    { reason }
  );
  return response.data;
};
